import React from 'react';
import DropdownIcon from "./icons/dropdown";
import {useContext} from "react";
import {SheetContext} from "./sheetContext";
import handleChartableData from "../utilities/handleChartableData";

const Dropdown = () => {
  const {allData, tabletoolId, setTableData, setChartData, setActiveSheet, activeSheet, setTabletoolContainer} = useContext(SheetContext)

  const setDropdownStateFunc = (e, index) => {
    e.preventDefault()

    setTableData(allData[index])
    setChartData(handleChartableData(allData[index]))
    setActiveSheet(index)
    setTabletoolContainer(() => document.querySelector('#tabletool-id-'+tabletoolId + " .sheet-"+activeSheet))
  }

  return (
    <div className="dropdown-container">
      <div className="dropdown spreadsheet-dropdown d-inline-block">
        <button className="btn btn-primary dropdown-toggle" type="button" id={`tt-dropdown-${tabletoolId}`}
                data-bs-toggle="dropdown" aria-expanded="false">
          {allData && allData[activeSheet].sheet_title}
          <DropdownIcon/>
        </button>
        <ul className="dropdown-menu" aria-labelledby={`tt-dropdown-${tabletoolId}`}>
          {allData && allData.map((sheet, index) => (
            <li key={index}>
              <a href="/" className={`${index === activeSheet && 'active'} dropdown-item`} onClick={(e) => setDropdownStateFunc(e, index)}>{sheet.sheet_title}</a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Dropdown;
